import { useForm, FormProvider } from "react-hook-form";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import type { SourceFile } from "../sources-types";
import { FTPInput } from "../../../../../components-new";
import { cancelButtonSx, primaryButtonSx } from "./addSourceStyles";
import { useSourceForm } from "./useSourceForm";

type CreateTableFormValues = { name: string };

interface CreateTableFormProps {
  parentId: string | null;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  editNode?: SourceFile | null;
}

export default function CreateTableForm({ parentId, open, onClose, onSuccess, editNode }: CreateTableFormProps) {
  const { isEdit, submitSource, renameNode } = useSourceForm(parentId, editNode ?? null, onSuccess);

  const methods = useForm<CreateTableFormValues>({
    defaultValues: { name: editNode?.name ?? "New table" },
  });

  const onSubmit = async (data: CreateTableFormValues) => {
    const name = data.name?.trim() || "New table";
    if (isEdit) {
      await renameNode(name);
      return;
    }
    await submitSource({ type: "table", name });
    methods.reset({ name: "New table" });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DialogTitle className="text-lg font-semibold">{isEdit ? "Edit Table" : "Create Table"}</DialogTitle>
          <DialogContent>
            <FTPInput name="name" label="Table name" className="mt-2" size="small" autoFocus />
          </DialogContent>
          <DialogActions className="px-6 pb-4">
            <Button type="button" variant="outlined" onClick={onClose} sx={cancelButtonSx}>Cancel</Button>
            <Button type="submit" variant="contained" sx={primaryButtonSx}>
              {isEdit ? "Save" : "Create"}
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
}
